module.exports = __webpack_public_path__ + "img/empty-quest.f130844f.svg";